import { createContext } from 'react';

const ProviderConfigContext = createContext();
export default ProviderConfigContext;
